import React from 'react';

// Helper to transform Supabase Storage URLs into low-res variants
// Supports URLs like:
//  - https://<project>.supabase.co/storage/v1/object/public/<bucket>/<path>
// Will convert to:
//  - https://<project>.supabase.co/storage/v1/render/image/public/<bucket>/<path>?width=160&quality=20
function toLowResSupabaseUrl(url, { width = 160, quality = 20 } = {}) {
  try {
    if (!url || typeof url !== 'string') return url;
    const u = new URL(url, window.location.origin);
    // Only transform supabase storage object URLs
    if (u.pathname.includes('/storage/v1/object/public/')) {
      u.pathname = u.pathname.replace('/storage/v1/object/', '/storage/v1/render/image/');
      u.searchParams.set('width', String(width));
      u.searchParams.set('quality', String(quality));
      return u.toString();
    }
    return url;
  } catch (e) {
    return url;
  }
}

function Image({
  src,
  alt = "Image Name",
  className = "",
  low = false, // when true, attempt to load a low-res variant
  lowWidth = 160,
  lowQuality = 20,
  loading = 'lazy',
  fetchPriority,
  sizes,
  ...props
}) {
  const computedSrc = low ? toLowResSupabaseUrl(src, { width: lowWidth, quality: lowQuality }) : src;

  return (
    <img
      src={computedSrc}
      alt={alt}
      className={className}
      loading={loading}
      decoding="async"
      {...(fetchPriority ? { fetchpriority: fetchPriority } : {})}
      {...(sizes ? { sizes } : {})}
      onError={(e) => {
        e.target.src = "/assets/images/no_image.png"
      }}
      {...props}
    />
  );
}

export default Image;

